<!-- @migration-task Error while migrating Svelte code: Can't migrate code with afterUpdate. Please migrate by hand. -->
<script>
	// @ts-nocheck

	import { goto } from '$app/navigation';
	import { onMount, onDestroy } from 'svelte';
	import allTours from '$lib/data/allTours.json';

	const validTours = Array.isArray(allTours) ? allTours : [];

	import { browser } from '$app/environment';
	import ListFilter from 'lucide-svelte/icons/list-filter';
	import { ArrowDownNarrowWide, ChevronDown } from 'lucide-svelte';

	import { Button } from '$lib/components/ui/button';
	import * as Card from '$lib/components/ui/card';
	import * as DropdownMenu from '$lib/components/ui/dropdown-menu';
	import * as Tabs from '$lib/components/ui/tabs';
	import GiftCard from '$lib/components/tours/GiftCard.svelte';
	import TourCard from '$lib/components/tours/TourCard.svelte';
	import { giftCards } from '$lib/data/giftCards.js';
	import { coalRiverWineHopper, wineHopperSiteLink } from '$lib/data/wineHopper';

	let displayedTours = $state([]);
	let filterBy = $state('dayTours');
	let sortBy = $state('featured');

	const dayTourCodes = [
		'P18ZC5',
		'PJHLE0',
		'PNVP8M',
		'P01GQC',
		'PQ5CJC',
		'PTC0KJ',
		'PCBKLS',
		'PNNK81',
		'PHJFAH',
		'PQKW4C',
		'PMPLBM'
	];

	const bundledDayTourCodes = [
		'PU9VRB',
		'P6GE12',
		'P1AHF0',
		'P0QKC2',
		'PHKZNS',
		'PKQPM9',
		'PTNCNK',
		'PM5WCG',
		'PBRPKL'
	];

	const multiDayTourCodes = ['PTWH1T', 'PVHGUQ', 'P1VDC1', 'P0V9R2', 'P8JLJC'];

	const shoreExcursionCodes = [
		'PM0VRV',
		'P0J8QR',
		'PB2LG2',
		'PSP9WG',
		'P9TVKQ',
		'PKLVUQ',
		'PHBQ6G',
		'PMPLBM',
		'PQ4FDL'
	];

	const privateTourCodes = [
		'P80WBP',
		'PUYDUT',
		'PMFU3K',
		'PVSUAB',
		'P0QZS7',
		'PXA0PL',
		'PKFPUC',
		'P9AM50',
		'PLQWG9'
	];

	function getOrderedTours(codes, productType) {
		return codes
			.map((code) => {
				const tour = validTours.find((t) => t.productCode === code);
				return tour ? { ...tour, productType } : null;
			})
			.filter(Boolean);
	}

	let allDayTours = $derived(
		validTours.filter((tour) => tour.productType === 'DAYTOUR' || tour.productType === 'DAY TOUR')
	);
	let allMultiDayTours = $derived(
		validTours.filter(
			(tour) => tour.productType === 'MULTIDAYTOUR' || tour.productType === 'MULTI DAY TOUR'
		)
	);
	let allShoreExcursions = $derived(
		validTours.filter(
			(tour) => tour.productType === 'SHOREEXCURSION' || tour.productType === 'SHORE EXCURSION'
		)
	);
	let allPrivateTours = $derived(
		validTours.filter(
			(tour) => tour.productType === 'PRIVATETOUR' || tour.productType === 'PRIVATE TOUR'
		)
	);

	let sortedDayTours = $derived(
		getOrderedTours(dayTourCodes, 'DAYTOUR').length > 0
			? getOrderedTours(dayTourCodes, 'DAYTOUR')
			: allDayTours
	);

	let sortedBundledDayTours = $derived(getOrderedTours(bundledDayTourCodes, 'DAYTOUR'));

	let sortedMultiDayTours = $derived(
		getOrderedTours(multiDayTourCodes, 'MULTIDAYTOUR').length > 0
			? getOrderedTours(multiDayTourCodes, 'MULTIDAYTOUR')
			: allMultiDayTours
	);

	let sortedShoreExcursions = $derived(
		getOrderedTours(shoreExcursionCodes, 'SHOREEXCURSION').length > 0
			? getOrderedTours(shoreExcursionCodes, 'SHOREEXCURSION')
			: allShoreExcursions
	);

	let sortedPrivateTours = $derived(
		getOrderedTours(privateTourCodes, 'PRIVATETOUR').length > 0
			? getOrderedTours(privateTourCodes, 'PRIVATETOUR')
			: allPrivateTours
	);

	function sortByPrice(toursToSort) {
		return toursToSort.sort((a, b) => a.advertisedPrice - b.advertisedPrice);
	}

	function sortByDuration(toursToSort) {
		return toursToSort.sort((a, b) => a.durationMinutes - b.durationMinutes);
	}

	$effect(() => {
		let toursToFilter = [];
		switch (filterBy) {
			case 'all': {
				const allOrderedCodes = [
					...dayTourCodes,
					...bundledDayTourCodes,
					...multiDayTourCodes,
					...shoreExcursionCodes,
					...privateTourCodes
				];
				const filteredAll = validTours.filter((tour) => allOrderedCodes.includes(tour.productCode));
				toursToFilter = allOrderedCodes
					.map((code) => filteredAll.find((t) => t.productCode === code))
					.filter(Boolean);
				break;
			}
			case 'dayTours':
				toursToFilter = sortedDayTours;
				break;
			case 'bundledDayTours':
				toursToFilter = sortedBundledDayTours;
				break;
			case 'multiDayTours':
				toursToFilter = sortedMultiDayTours;
				break;
			case 'shoreExcursions':
				toursToFilter = sortedShoreExcursions;
				break;
			case 'privateTours':
				toursToFilter = sortedPrivateTours;
				break;
			case 'giftCards':
				toursToFilter = [];
				break;
			default: {
				const defaultOrderedCodes = [
					...dayTourCodes,
					...bundledDayTourCodes,
					...multiDayTourCodes,
					...shoreExcursionCodes,
					...privateTourCodes
				];
				const filteredDefault = validTours.filter((tour) =>
					defaultOrderedCodes.includes(tour.productCode)
				);
				toursToFilter = defaultOrderedCodes
					.map((code) => filteredDefault.find((t) => t.productCode === code))
					.filter(Boolean);
				break;
			}
		}

		if (sortBy === 'price') {
			displayedTours = sortByPrice([...toursToFilter]);
		} else if (sortBy === 'duration') {
			displayedTours = sortByDuration([...toursToFilter]);
		} else {
			displayedTours = toursToFilter;
		}
	});

	const filterLabels = {
		all: 'All Tours',
		dayTours: 'Day Tours',
		bundledDayTours: 'Bundled Day Tours',
		multiDayTours: 'Multi-day Tours',
		shoreExcursions: 'Shore Excursions',
		privateTours: 'Private Tours',
		giftCards: 'Gift Cards'
	};

	function setFilterAndUpdateHash(value) {
		filterBy = value;
		updateURL(value);
	}

	function updateURL(value) {
		if (browser) {
			const url = new URL(window.location);
			url.hash = value;
			goto(url.toString(), { replaceState: true, noscroll: true });
		}
	}

	function getFilterFromHash() {
		if (browser) {
			const hash = window.location.hash.slice(1);
			if (!hash) return 'all';
			return [
				'all',
				'dayTours',
				'bundledDayTours',
				'multiDayTours',
				'shoreExcursions',
				'privateTours',
				'giftCards'
			].includes(hash)
				? hash
				: 'all';
		}
	}

	function handleHashChange() {
		filterBy = getFilterFromHash();
	}

	onMount(() => {
		filterBy = getFilterFromHash() || 'all';
		window.addEventListener('hashchange', handleHashChange);
	});

	onDestroy(() => {
		if (browser) {
			window.removeEventListener('hashchange', handleHashChange);
		}
	});
</script>

<main class="grid flex-1 items-start gap-4 sm:px-6 sm:py-0 md:gap-8">
	<h1 class="px-4 pt-2 font-heading text-3xl font-bold tracking-tight lg:text-4xl">
		Book with Tassie Tours
	</h1>
	<Tabs.Root value={filterBy} onValueChange={setFilterAndUpdateHash}>
		<div class="flex items-center px-4">
			<Tabs.List class="hidden h-full rounded-full px-2 py-1.5 lg:flex">
				<Tabs.Trigger
					class="rounded-full font-semibold data-[state=active]:bg-tt-red data-[state=active]:text-background"
					value="dayTours">Day tours</Tabs.Trigger
				>
				<Tabs.Trigger
					class="rounded-full font-semibold data-[state=active]:bg-tt-red data-[state=active]:text-background"
					value="bundledDayTours">Bundled day tours</Tabs.Trigger
				>
				<Tabs.Trigger
					class="rounded-full font-semibold data-[state=active]:bg-tt-red data-[state=active]:text-background"
					value="multiDayTours">Multi-day tours</Tabs.Trigger
				>
				<Tabs.Trigger
					class="rounded-full font-semibold data-[state=active]:bg-tt-red data-[state=active]:text-background"
					value="shoreExcursions">Shore excursions</Tabs.Trigger
				>
				<Tabs.Trigger
					class="rounded-full font-semibold data-[state=active]:bg-tt-red data-[state=active]:text-background"
					value="privateTours">Private tours</Tabs.Trigger
				>
				<Tabs.Trigger
					class="rounded-full font-semibold data-[state=active]:bg-tt-red data-[state=active]:text-background"
					value="giftCards">Gift cards</Tabs.Trigger
				>
				<Tabs.Trigger
					class="rounded-full font-semibold data-[state=active]:bg-tt-red data-[state=active]:text-background"
					value="all">All tours</Tabs.Trigger
				>
			</Tabs.List>
			<div class="flex items-center gap-2 lg:hidden">
				<DropdownMenu.Root>
					<DropdownMenu.Trigger>
						<Button variant="outline" size="sm" class="h-9 gap-1.5 rounded-full pl-3 pr-2">
							<ListFilter class="h-3.5 w-3.5" />
							<span class="whitespace-nowrap">Filter:</span>
							<span
								class="whitespace-nowrap rounded-full bg-[#194139]/10 px-2 py-0.5 text-xs font-semibold text-[#194139]"
							>
								{filterLabels[filterBy] ?? 'All Tours'}
							</span>
							<ChevronDown class="h-3.5 w-3.5" />
						</Button>
					</DropdownMenu.Trigger>
					<DropdownMenu.Content align="end" class="ml-4">
						<DropdownMenu.RadioGroup value={filterBy} onValueChange={setFilterAndUpdateHash}>
							<DropdownMenu.RadioItem value="all">All Tours</DropdownMenu.RadioItem>
							<DropdownMenu.RadioItem value="dayTours">Day Tours</DropdownMenu.RadioItem>
							<DropdownMenu.RadioItem value="bundledDayTours"
								>Bundled Day Tours</DropdownMenu.RadioItem
							>
							<DropdownMenu.RadioItem value="multiDayTours">Multi-day Tours</DropdownMenu.RadioItem>
							<DropdownMenu.RadioItem value="shoreExcursions"
								>Shore Excursions</DropdownMenu.RadioItem
							>
							<DropdownMenu.RadioItem value="privateTours">Private Tours</DropdownMenu.RadioItem>
							<DropdownMenu.RadioItem value="giftCards">Gift Cards</DropdownMenu.RadioItem>
						</DropdownMenu.RadioGroup>
					</DropdownMenu.Content>
				</DropdownMenu.Root>
			</div>
			<div class:hidden={filterBy === 'giftCards'} class="ml-auto flex items-center gap-2">
				<DropdownMenu.Root>
					<DropdownMenu.Trigger>
						<Button variant="outline" size="sm" class="h-8 gap-1 rounded-full">
							<ArrowDownNarrowWide class="h-3.5 w-3.5" />
							<span class="sr-only sm:not-sr-only sm:whitespace-nowrap">Sort tours</span>
						</Button>
					</DropdownMenu.Trigger>
					<DropdownMenu.Content align="end">
						<DropdownMenu.Label>Sort by</DropdownMenu.Label>
						<DropdownMenu.Separator />
						<DropdownMenu.RadioGroup value={sortBy} onValueChange={(v) => (sortBy = v)}>
							<DropdownMenu.RadioItem value="featured">Featured</DropdownMenu.RadioItem>
							<DropdownMenu.RadioItem value="price">Price</DropdownMenu.RadioItem>
							<DropdownMenu.RadioItem value="duration">Duration</DropdownMenu.RadioItem>
						</DropdownMenu.RadioGroup>
					</DropdownMenu.Content>
				</DropdownMenu.Root>
			</div>
		</div>

		<Tabs.Content value="all">
			<Card.Root class="border-none">
				<Card.Header>
					<Card.Title>Explore Tasmania with Tassie Tours</Card.Title>
					<Card.Description class="max-w-2xl">
						Adventure Tasmania with us as we explore Bruny Island, Cradle Mountain, Mt Wellington,
						Wineglass Bay, Bonorong Park, Maria Island, Greater Hobart, Port Arthur and more! Get
						the best deals on Hobart Tours here!
					</Card.Description>
				</Card.Header>
				<Card.Content>
					<div class="grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-3 lg:gap-12">
						{#each displayedTours as tour}
							<TourCard {tour} />
						{/each}
					</div>
				</Card.Content>
				<Card.Footer>
					<div class="text-xs text-muted-foreground">
						Showing <strong>all</strong> available tours
					</div>
				</Card.Footer>
			</Card.Root>
		</Tabs.Content>

		<Tabs.Content value="dayTours">
			<Card.Root class="border-none shadow-none">
				<Card.Header>
					<Card.Title>Day Tours</Card.Title>
					<Card.Description class="max-w-2xl">
						Get the best deals on Hobart Tours here! See Australia's best kept secret and hear the
						many stories that have made this island so very desirable. If you're on the lookout for
						day tours from Hobart, Tassie Tours offers a range of exciting discounted day tours in
						Tasmania to choose from.
					</Card.Description>
				</Card.Header>
				<Card.Content>
					<div class="grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-3 lg:gap-12">
						{#each sortedDayTours as tour}
							<TourCard {tour} />
						{/each}

						<!-- Operated by our sister company, The Wine Hopper — booked on their own site -->
						<TourCard tour={coalRiverWineHopper} logoOverlay externalHref={wineHopperSiteLink} />

						<!-- Promotional Card -->
						<a
							href="/tours#dayTours"
							data-sveltekit-prefetch
							onclick={(e) => {
								e.preventDefault();
								window.scrollTo({ top: 0, behavior: 'smooth' });
							}}
							class="col-span-1 block h-full"
						>
							<div
								class="group relative flex h-full min-h-[380px] w-full items-center justify-center overflow-hidden rounded-2xl shadow-lg transition-all hover:shadow-xl"
							>
								<enhanced:img
									src="$lib/assets/images/wineglass.jpg"
									alt="Book multiple day tours and save"
									class="absolute inset-0 h-full w-full object-cover"
									sizes="(min-width: 1024px) 33vw, (min-width: 768px) 50vw, 100vw"
									loading="lazy"
								/>
								<div
									class="absolute inset-0 bg-gradient-to-t from-foreground/80 via-foreground/40 to-foreground/20"
								></div>
								<div
									class="relative z-10 flex flex-col items-center justify-center px-6 text-center"
								>
									<h3
										class="mb-3 font-heading text-2xl font-bold tracking-tight text-background lg:text-3xl"
									>
										<span class="text-[#ffd451] underline">Save 15%</span> on Multiple Tours
									</h3>
									<p class="max-w-xs text-base text-background/90">
										Book 2 or more day tours and receive <span class="font-black">15% OFF</span> your
										entire order
									</p>
								</div>
							</div>
						</a>
					</div>
				</Card.Content>
				<Card.Footer>
					<div class="text-xs text-muted-foreground">
						Showing <strong>all</strong> available day tours
					</div>
				</Card.Footer>
			</Card.Root>
		</Tabs.Content>

		<Tabs.Content value="bundledDayTours">
			<Card.Root class="border-none">
				<Card.Header>
					<Card.Title>Bundled Day Tours</Card.Title>
					<Card.Description class="max-w-2xl">
						Make the most of your time in Tasmania by combining our most popular day tours into one
						great-value package. Our bundled day tours pair iconic destinations across multiple
						days, so you can see more of the island while saving on every tour you add.
					</Card.Description>
				</Card.Header>
				<Card.Content>
					<div class="grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-3 lg:gap-12">
						{#each sortedBundledDayTours as tour}
							<TourCard {tour} />
						{/each}
					</div>
				</Card.Content>
				<Card.Footer>
					<div class="text-xs text-muted-foreground">
						Showing <strong>all</strong> available bundled day tours
					</div>
				</Card.Footer>
			</Card.Root>
		</Tabs.Content>

		<Tabs.Content value="multiDayTours">
			<Card.Root class="border-none">
				<Card.Header>
					<Card.Title>Multi-day Tours</Card.Title>
					<Card.Description class="max-w-2xl">
						It's not only easier but your travelling with a award winning tour company who prides
						itself on professionalism, fun and consistency. It will also give you a chance to meet
						more of the Tassie Tours team who will all share their unique Tasmanian story.
					</Card.Description>
				</Card.Header>
				<Card.Content>
					<div class="grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-3 lg:gap-12">
						{#each sortedMultiDayTours as tour}
							<TourCard {tour} />
						{/each}
					</div>
				</Card.Content>
				<Card.Footer>
					<div class="text-xs text-muted-foreground">
						Showing <strong>all</strong> available multi-day tours
					</div>
				</Card.Footer>
			</Card.Root>
		</Tabs.Content>

		<Tabs.Content value="shoreExcursions">
			<Card.Root class="border-none">
				<Card.Header>
					<Card.Title>Shore Excursions</Card.Title>
					<Card.Description class="max-w-2xl">
						Coming to Tasmania via Cruise ship and want to maximise your time while you are on dry
						land? We offer tours state wide to all the major tourist attractions at an affordable,
						fair price. We are a professional team who love showcasing Tasmania to people from all
						around the world.
					</Card.Description>
				</Card.Header>
				<Card.Content>
					<div class="grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-3 lg:gap-12">
						{#each sortedShoreExcursions as tour}
							<TourCard {tour} />
						{/each}
					</div>
				</Card.Content>
				<Card.Footer>
					<div class="text-xs text-muted-foreground">
						Showing <strong>all</strong> available shore excursions
					</div>
				</Card.Footer>
			</Card.Root>
		</Tabs.Content>

		<Tabs.Content value="privateTours">
			<Card.Root class="border-none">
				<Card.Header>
					<Card.Title>Private Tours</Card.Title>
					<Card.Description class="max-w-2xl">
						Whether you're an adventurous solo traveller or part of a small to medium-sized group,
						our private tour packages are the ultimate way to discover the wonders of Tasmania. Let
						us take care of all the details while you immerse yourself in the beauty and charm of
						this incredible island.
					</Card.Description>
				</Card.Header>
				<Card.Content>
					<div class="grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-3 lg:gap-12">
						{#each sortedPrivateTours as tour}
							<TourCard {tour} />
						{/each}
					</div>
				</Card.Content>
				<Card.Footer>
					<div class="text-xs text-muted-foreground">
						Showing <strong>all</strong> available private tours
					</div>
				</Card.Footer>
			</Card.Root>
		</Tabs.Content>

		<Tabs.Content value="giftCards">
			<Card.Root class="border-none shadow-none">
				<Card.Header>
					<Card.Title>Gift Cards</Card.Title>
					<Card.Description class="max-w-2xl">
						Give them the freedom to choose their own Tassie Tours adventure. Gift cards are
						available from $100 to $500 and can be used towards any Tassie Tours experience.
					</Card.Description>
				</Card.Header>
				<Card.Content>
					<div class="grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-3 lg:gap-12">
						{#each giftCards as giftCard}
							<GiftCard {giftCard} />
						{/each}
					</div>
				</Card.Content>
				<Card.Footer>
					<div class="text-xs text-muted-foreground">
						Showing <strong>all</strong> available gift cards
					</div>
				</Card.Footer>
			</Card.Root>
		</Tabs.Content>
	</Tabs.Root>
</main>
